import styles from "./hoverBAEmail.scss";
const HoverBAEmail = (props) => {
  //const [checkOpen, setcheckOpen] = useState(false);
    let iconClose=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    let style1=styles.popUp1;
    let style2=styles.popUp2;
    let style3=styles.popUp3;
    let popUp=props.preferenceData && props.preferenceData.length===1 ? style1 : props.preferenceData && props.preferenceData.length===2 ? style2 : style3;
    //alert(popUp);
  return (
    <div className={popUp}>
     <div className={styles.popupContent+ ' ' + styles.bApopupContent}>
     <div className={styles.closeIcon}>  <img className={styles.closeIconAlign} 
        src={iconClose} onClick={props.handleClose} alt="Close Icon"  /> </div>
     <div className={styles.marginSpace}>
     {props.preferenceData && props.preferenceData.map(email =>

        <p className={styles.hoverTable}>{email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</p>
        )
      }
     </div>
      {/* <table>
      <thead className={styles.closeIcon}>  <img className={styles.closeIconAlign} 
        src={iconClose} onClick={props.handleClose}  /></thead>
        <tbody>{props.preferenceData && props.preferenceData.map(email =>
         <tr><td className={styles.hoverTable}>{email}</td></tr>
          )}</tbody>
      </table> */}
    </div> 
  
     </div>
);};
 
export default HoverBAEmail;
